import { render, staticRenderFns } from "./CompanyClassifications.vue?vue&type=template&id=87f34fea"
import script from "./CompanyClassifications.vue?vue&type=script&lang=js"
export * from "./CompanyClassifications.vue?vue&type=script&lang=js"
import style0 from "./CompanyClassifications.vue?vue&type=style&index=0&id=87f34fea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports